import { formData, authApi } from "utils";

export const createBundle = (data) => () =>
    authApi.post(`/product_bundles/create`, formData(data))
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
            throw err
        });

export const getBundles = (name) => () =>
    authApi.get(`/product_bundles/shop/${name}`)
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
            throw err
        });

export const updateBundle = (data) => () =>
    authApi.post(`/product_bundles/update`, formData(data))
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
            throw err
        })

export const deleteBundle = (id) => () =>
    authApi.post(`/product_bundles/delete`, formData({ uniqid: id }))
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
            throw err
        })

export const getBundleByID = (id) => () =>
    authApi.get(`/product_bundles/unique/${id}`)
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
            throw err
        })
